export default "__VITE_ASSET__0e628e5e__"